(function () {
  // Fixed anchor so every visitor sees the same countdown, across reloads.
  var ANCHOR = Date.parse('2026-10-15T00:00:00-06:00');
  var CYCLE = 48 * 3600 * 1000; // 48h, restarts at 48:00:00
  var el = document.getElementById('countdown');
  var live = document.getElementById('countdown-live');
  if (!el) return;
  var lastMinute = null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function remainingMs(now) {
    var elapsed = ((now - ANCHOR) % CYCLE + CYCLE) % CYCLE; // safe for times before the anchor
    return CYCLE - elapsed;
  }

  function render() {
    var total = Math.ceil(remainingMs(Date.now()) / 1000);
    if (total > 48 * 3600) total = 48 * 3600;
    var h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60), sec = total % 60;
    var text = 'T\u2212' + pad(h) + ':' + pad(m) + ':' + pad(sec);
    var html = '';
    for (var i = 0; i < text.length; i++) html += '<span>' + text.charAt(i) + '</span>';
    el.innerHTML = html;
    var minuteKey = h * 60 + m;
    if (live && minuteKey !== lastMinute) {
      lastMinute = minuteKey;
      live.textContent = 'Countdown: ' + h + ' hours ' + m + ' minutes remaining.';
    }
  }

  render();
  // Align ticks to the wall-clock second.
  setTimeout(function () { render(); setInterval(render, 1000); }, 1000 - (Date.now() % 1000));
})();
